module.exports = __webpack_public_path__ + "img/strip_head_c.0da9ffce.jpg";